import React from 'react';
import styles from './ShadowSeparator.module.scss';

const ShadowSeparator = () => <div className={styles.separator} />;

export default ShadowSeparator;
